var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.343,
    height: 24.352,
    viewBox: "0 0 24.343 24.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.04,
    y1: 2.516,
    x2: 0.259,
    y2: -0.717,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M94.44,10.833a.793.793,0,0,0-.784-.6,2.679,2.679,0,0,1-1.841-4.678.677.677,0,0,0,.075-.923,12.281,12.281,0,0,0-1.931-1.948.679.679,0,0,0-.928.075A2.8,2.8,0,0,1,86,3.444,2.713,2.713,0,0,1,84.355.8a.682.682,0,0,0-.6-.714A12.271,12.271,0,0,0,81.018.079a.68.68,0,0,0-.6.694,2.706,2.706,0,0,1-1.668,2.6,2.825,2.825,0,0,1-3.015-.684.677.677,0,0,0-.918-.076,12.087,12.087,0,0,0-1.968,1.948.684.684,0,0,0,.07.928A2.7,2.7,0,0,1,73.6,8.529a2.815,2.815,0,0,1-2.65,1.637.662.662,0,0,0-.7.6,11.98,11.98,0,0,0,0,2.767.784.784,0,0,0,.794.6,2.679,2.679,0,0,1,2.5,1.671,2.711,2.711,0,0,1-.68,3.01.677.677,0,0,0-.075.921,12.045,12.045,0,0,0,1.926,1.948.68.68,0,0,0,.928-.07,2.807,2.807,0,0,1,3.039-.689,2.7,2.7,0,0,1,1.644,2.642.682.682,0,0,0,.6.714,12.612,12.612,0,0,0,1.4.08,11.451,11.451,0,0,0,1.337-.076.679.679,0,0,0,.6-.7,2.7,2.7,0,0,1,1.663-2.6,2.81,2.81,0,0,1,3.008.694.677.677,0,0,0,.918.076,12.283,12.283,0,0,0,1.968-1.948.68.68,0,0,0-.071-.928,2.679,2.679,0,0,1,1.812-4.688h.151a.682.682,0,0,0,.714-.6,12.488,12.488,0,0,0,0-2.759ZM82.363,16.266a4.065,4.065,0,1,1,2.869-1.191A4.06,4.06,0,0,1,82.363,16.266Z",
    transform: "translate(-70.174 -0.006)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.4f482d39dfad1bbee4b2de27948f5510.svg";
export { ForwardRef as ReactComponent };